<div class="warehouse-group-filter__wrapper flex pt-2">
  <div>
    <lum-ui-field-label label="Label"></lum-ui-field-label>
    <lum-ui-input
      placeholder="Search..."
      class="w-50 mr-2"
      [debounceTime]="500"
      (inputChangeEvent)="onFilterUpdate($event, 'label')"
    ></lum-ui-input>
  </div>
</div>
